import APIKit from "../Allapis/Apikit/apikit";

export const getAllUsers = async () => {
  let result;
  try {
    const url = `/users/allUsers`;
    result = await APIKit.get(url);
    return result?.data;
  } catch (e) {
    return e.response ? e.response.data : e;
  }
};

export const updateUser = async (id) => {
  let result;
  try {
    const url = `/users/${id}`;
    result = await APIKit.get(url);
    return result?.data;
  } catch (e) {
    return e.response ? e.response.data : e;
  }
};
